module.exports = __webpack_public_path__ + "img/index26.53be1546.png";